const MODE = {
  NEW: 'new',
  VIEW: 'view',
  EDIT: 'edit',
};

const TAB = {
  OVERVIEW: 'overview',
};

const PROMO_CODE = {
  MODE,
  TAB,
};

export default PROMO_CODE;



/** WEBPACK FOOTER **
 ** ./client/constants/promo-code.js
 **/